import { UPDATE_BUSINESS_ALERT, DELETE_BUSINESS_ALERT } from 'actions/types';
import { READ } from 'constants/alerts';

const INITIAL_STATE = {};

const businessAlerts = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'SET_BUSINESS_ALERTS':
      return { ...action.businessAlerts };
    case UPDATE_BUSINESS_ALERT:
      return Object.assign({}, state, { [action.id]: { ...state[action.id], ...action.updatedAlert } });
    case DELETE_BUSINESS_ALERT:
      const stateCopy = Object.assign({}, state);
      delete stateCopy[action.id];

      return stateCopy;
    case 'CLEAR_BUSINESS_ALERTS':
      return INITIAL_STATE;
    case 'TOGGLE_ALERT_SHOW_HIDE':
      const newState = { ...state };
      newState[action.alertId].show = !state[action.alertId].show;
      newState[action.alertId].readStatus = READ;

      return { ...state, ...newState };
    default:
      return state;
  }
};

export default businessAlerts;
